import { Suspense } from 'react';

import { cn } from '@/lib/utils';

import Heading from '@/components/atoms/heading';

import { SearchBar } from './SearchBar';

type SearchFinalProps = {
  slug?: string;
  classNames?: {
    root?: string;
  };
  searchWithin?: 'faq' | 'all';
  title: string;
  description: React.ReactNode;
  image: React.ReactNode;
  links: React.ReactNode;
};

export async function HeroWithSearch({
  slug,
  searchWithin,
  image,
  links,
  title,
  description,
}: SearchFinalProps) {
  return (
    <div className='flex w-full flex-row items-center gap-6'>
      <div className='flex w-full flex-col'>
        <Heading level='h1' classNames={{ root: 'mb-6' }}>
          {title}
        </Heading>
        <div className='text-neutral-N99 mb-9'>{description}</div>
        <div
          className={cn('flex flex-wrap gap-6 pb-8 md:pb-12')}
          data-tracker-component='buttons'
        >
          {links}
        </div>
        <Suspense>
          <SearchBar slug={slug} searchWithin={searchWithin} />
        </Suspense>
      </div>
      <div className='relative hidden h-full w-full max-w-[360px] items-center justify-center md:flex'>
        {image}
      </div>
    </div>
  );
}
